import CheckBox1 from "@assets/svg/CheckBox1.svg?react";
import PropertyImg from "@assets/svg/PropertyImg.svg?react";
import { Divider } from "@mui/material";
import {
  RowWrapper,
  PropertyBox,
  InputSection,
  InputBox,
  InputColumn,
  InputRow,
  Label,
  StyledInput,
  HintLink,
} from "./styles/ComparePropertiesModal";
import useBreakPoinst from "@hooks/useBreakPoinst";

interface CompareRow1Props {
  showText: boolean;
  image: string;
  title: string;
  propertyId: string;
  hotelId: string;
  hasError: boolean;
  hasSuccess: boolean;
  onHotelIdChange: (hotelId: string) => void;
}

const CompareRow1 = ({
  showText,
  image,
  title,
  propertyId,
  hotelId,
  hasError,
  hasSuccess,
  onHotelIdChange,
}: CompareRow1Props) => {
  const { isPhone } = useBreakPoinst();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onHotelIdChange(e.target.value);
  };

  // Determine icon color based on state
  const getIconColor = () => {
    if (hasSuccess) return "#22c55e"; // Green for success
    if (hasError) return "#ef4444"; // Red for error
    return "#475467"; // Default color
  };

  // Determine input styling based on state
  const getInputStyles = () => {
    if (hasSuccess) {
      return {
        border: "1px solid #22c55e",
        backgroundColor: "#f0fdf4",
      };
    }
    if (hasError) {
      return {
        border: "1px solid #ff4444",
        backgroundColor: "#fff5f5",
      };
    }
    return {
      border: "1px solid #e9e9e7",
      backgroundColor: "#f8fafc",
    };
  };

  const inputStyles = getInputStyles();

  return (
    <RowWrapper $isPhone={isPhone}>
      <PropertyBox>
        {/* <PropertyImg width={63} height={30} /> */}
        {image && (
          <img
            src={image}
            alt={title}
            style={{ width: 63, height: 30, objectFit: "cover" }}
          />
        )}
        {/* شقة مميزة في النرجس */}
        {title}
      </PropertyBox>
      <InputSection>
        <InputBox style={inputStyles}>
          <InputColumn>
            <InputRow>
              <Label>رمز ID الخاص للعقار</Label>
              <Divider
                orientation="vertical"
                flexItem
                style={{
                  height: "24px",
                  marginInline: "8px",
                  alignSelf: "center",
                }}
              />
              <StyledInput
                type="text"
                placeholder="ادخل رمز ID الخاص للعقار"
                value={hotelId}
                onChange={handleInputChange}
                className="input-with-placeholder-padding"
                style={{
                  backgroundColor: inputStyles.backgroundColor,
                }}
              />
            </InputRow>
          </InputColumn>
          <div
            style={{
              color: getIconColor(),
              opacity: hasSuccess || hasError ? 1 : 0.56,
            }}
          >
            <CheckBox1
              width={22}
              height={22}
              style={{
                fill: "currentColor",
                filter: hasSuccess
                  ? "drop-shadow(0 0 2px rgba(34, 197, 94, 0.3))"
                  : hasError
                    ? "drop-shadow(0 0 2px rgba(239, 68, 68, 0.3))"
                    : "none",
              }}
            />
          </div>
        </InputBox>
        {showText && <HintLink>كيف احصل على رمز ID الخاص للعقار؟</HintLink>}
      </InputSection>
    </RowWrapper>
  );
};

export default CompareRow1;
